import type { FC, ReactNode } from 'react'

interface HighlightProps {
    text: string
    terms: string[]
}

const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

const Highlight: FC<HighlightProps> = ({ text, terms }): ReactNode => {
    const usable = terms.filter(term => term.length > 1)

    if (!usable.length) return text

    const pattern = new RegExp(`(${usable.map(escapeRegExp).join('|')})`, 'gi')
    const parts = text.split(pattern)

    return (
        <>
            {parts.map((part, index) => (
                index % 2 === 1
                    ? <mark key={index} className='search-highlight'>{part}</mark>
                    : <span key={index}>{part}</span>
            ))}
        </>
    )
}

export default Highlight
